import type { ReactNode } from 'react';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils';

/**
 * "Learn more →" — the consistent hand-off from a home-page section to its
 * deeper product-page section. Direction-aware arrow (nudges on hover), brand
 * green, underline-on-hover. Works in server + client sections.
 */
export function SectionLink({
  href,
  children,
  className,
}: {
  href: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Link
      href={href}
      className={cn(
        'group inline-flex items-center gap-1.5 text-small font-semibold text-primary underline-offset-4 transition-brand hover:underline',
        className,
      )}
    >
      {children}
      <svg
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden
        className="size-3.5 transition-transform group-hover:translate-x-0.5 rtl:-scale-x-100"
      >
        <path
          d="M3 8h10m0 0-4-4m4 4-4 4"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Link>
  );
}
